<template>
    <div id="funcionario-listagem">
        <my-tour
            v-if="itens.length > 0"
            :steps="steps"
            name="steps-categorias"
        ></my-tour>
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina titulo="Categorias" />
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <table class="bordered striped">
                                <thead>
                                    <tr>
                                        <th id="colNome">Nome</th>
                                        <th id="colAcoes" class="center">
                                            Ações
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in paginationConfig.itens"
                                        :key="item.categoria_id"
                                    >
                                        <td>{{ item.categoria_nome }}</td>
                                        <td class="center">
                                            <router-link
                                                :to="
                                                    '/categoria/editar/' +
                                                        item.categoria_id
                                                "
                                                class="btn-floating btn-flat btn-transparent"
                                            >
                                                <i
                                                    class="material-icons text-default"
                                                    >mode_edit</i
                                                >
                                            </router-link>

                                            <botao-remover
                                                :identificador="
                                                    item.categoria_id
                                                "
                                                :url="
                                                    `categoria/${item.categoria_id}`
                                                "
                                                @deleted="
                                                    ({ item }) =>
                                                        paginationConfig.itens.splice(
                                                            paginationConfig.itens.indexOf(
                                                                item
                                                            ),
                                                            1
                                                        )
                                                "
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <Pagination
                                v-if="paginationConfig.itens.length > 0"
                                :perPage="paginationConfig.perPage"
                                :qty="paginationConfig.qty"
                                :setCurrent="setCurrent"
                                :current="paginationConfig.current"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
        <div
            id="fixed-action-btn"
            class="fixed-action-btn active"
            style="bottom: 50px; right: 19px;"
        >
            <router-link
                to="/categoria/cadastro"
                id="add-categoria"
                class="btn-floating btn-large btn-default"
            >
                <i class="material-icons">add</i>
            </router-link>
        </div>
    </div>
</template>
<script>
import BotaoRemover from "@/components/common/BotaoRemover";
import TituloPagina from "@/components/common/TituloPagina";
import { get } from "@/helpers/api";

import Pagination from "@/components/common/Pagination/Pagination";
import ListHelper from "@/helpers/list";

import MyTour from "@/components/common/MyTour.vue";

import {
    DONO,
    GERENTE,
    CORRETOR,
    ESPECIALISTA,
    LIDER,
    MASTER,
    PARCEIRO
} from "@/constants/funcionarioCargo.js";
import TourHelper from "@/helpers/tour";
import Auth from "@/store/auth";

export default {
    components: {
        BotaoRemover,
        TituloPagina,
        Pagination,
        MyTour
    },
    data: () => ({
        paginationConfig: {
            perPage: 20,
            qty: 1,
            current: 1,
            itens: []
        },
        steps: [
            {
                parent: "#colNome",
                target: "#colNome",
                content: "Podemos ver a lista de categorias já cadastrados...",
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: "bottom",
                    menu: false
                }
            },
            {
                parent: "#colAcoes",
                target: "#colAcoes",
                content: "Aqui podemos editar o categoria!",
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: "bottom",
                    menu: false
                }
            },
            {
                parent: "#add-categoria",
                target: "#add-categoria",
                content: "Ou então cadastrar um novo!",
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: "right",
                    bgTransparent: true,
                    bgClass: "color-default",
                    menu: true,
                    route: "/categoria/cadastro"
                }
            },
            {
                parent: "",
                target: "",
                content: "",
                params: {
                    cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: "left",
                    menu: false
                }
            }
        ],
        itens: []
    }),
    created() {
        // verifica se pode acessar componente
        if (
            Auth.getCargoUsuario() !== MASTER &&
            [DONO, GERENTE].indexOf(Auth.getCargoUsuario()) === -1
        ) {
            this.$router.push("/sempermissao");
        }
        this.steps = TourHelper.createSteps(this.steps);
        let self = this;
        get("categoria").then(function(response) {
            self.itens = response.data.result.data;
            self.paginationConfig.qty = self.itens.length;
            self.paginationConfig.itens = ListHelper.getInterval(
                self.itens,
                self.paginationConfig.current,
                self.paginationConfig.perPage
            );
        });
    },
    watch: {
        "paginationConfig.current"() {
            this.paginationConfig.itens = ListHelper.getInterval(
                this.itens,
                this.paginationConfig.current,
                this.paginationConfig.perPage
            );
        }
    },
    methods: {
        setCurrent(current) {
            this.paginationConfig.current = current;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/categorias/Listagem.vue